import React, { useRef, useEffect } from 'react';
import { getDegradedColor } from './utils';

const SubThemeCircle = ({ subTheme, color, position, progress, onClick, isExpanded, parentPosition }) => {
  const circleRef = useRef(null);
  const getBorderColor = (score) => {
    if (score <= 50) return `hsl(${score * 1.2}, 70%, 50%)`;
    return `hsl(${60 + (score - 50) * 1.2}, 70%, 50%)`;
  };
  const degradedColor = getDegradedColor(color, true);

  useEffect(() => {
    const subThemeElement = circleRef.current;
    if (subThemeElement) setTimeout(() => subThemeElement.classList.add('animate'), 300);
  }, [subTheme]);

  const absoluteStartX = parentPosition.x + position.x;
  const absoluteStartY = parentPosition.y + position.y;

  return (
    <div
      ref={circleRef}
      className={`sub-theme-circle relative ${isExpanded ? 'expanded' : ''}`}
      style={{
        '--start-x': `${absoluteStartX}px`,
        '--start-y': `${absoluteStartY}px`,
        transform: isExpanded ? 'translate(0, 0)' : `translate(${position.x}px, ${position.y}px)`,
        background: `linear-gradient(135deg, ${degradedColor}, ${degradedColor}80)`,
        '--progress': `${progress}`,
        '--border-color': getBorderColor(progress),
      }}
      data-subtheme={subTheme}
      onClick={(e) => {
        e.stopPropagation();
        onClick(subTheme);
      }}
    >
      <div
        className="border-gradient absolute inset-0 rounded-full"
        style={{
          border: '0px solid transparent',
          background: `conic-gradient(${getBorderColor(progress)} ${progress}%, transparent 0%)`,
          zIndex: 5,
        }}
      />
      <div className="relative z-10 h-full w-full flex items-center justify-center">
        <span>{subTheme}</span>
      </div>
    </div>
  );
};

export default SubThemeCircle;